import api from './api';
import type { ChatMessage, ChatOption, IntakeSummary } from '../types';

export interface IntakeChatData {
  lesson_id: string;
  version: number;
  message: string;
  history: ChatMessage[];
}

export interface IntakeChatResponse {
  reply: string;
  summary?: IntakeSummary;
  options?: ChatOption[];
}

export const intakeChatService = {
  sendMessage: async (data: IntakeChatData): Promise<IntakeChatResponse> => {
    const response = await api.post<IntakeChatResponse>('/ai/intake-chat', data);
    return response.data;
  },
};
